import React from 'react'
import loadable from '@loadable/component'

const loading = () => (
  <div class="loader loader--show">
    <div class="loader__spin">&nbsp;</div>
  </div>
)

export const AdDetail = loadable(
  () => import(/* webpackChunkName: "adDetail" */ 'container/AdDetail'),
  {
    fallback: loading,
  }
)

export const Recapture = loadable(
  () => import(/* webpackChunkName: "recapture" */ 'container/Recapture'),
  {
    fallback: loading,
  }
)

export const Search = loadable(
  () => import(/* webpackChunkName: "search" */ 'container/NovaRBRedirect'),
  {
    fallback: loading,
  }
)

export const NotFound = loadable(
  () => import(/* webpackChunkName: "notFound" */ 'container/NotFound'),
  {
    fallback: loading,
  }
)

export const HotDeal = loadable(
  () => import(/* webpackChunkName: "hotDeal" */ 'container/HotDeal'),
  {
    fallback: loading,
  }
)

export const SiteMap = loadable(
  () => import(/* webpackChunkName: "siteMap" */ 'container/SiteMap'),
  {
    fallback: loading,
  }
)

export const LocationSiteMap = loadable(
  () =>
    import(/* webpackChunkName: "locationSiteMap" */ 'container/LocationSiteMap'),
  {
    fallback: loading,
  }
)

export const Financing = loadable(
  () => import(/* webpackChunkName: "financing" */ 'container/Financing'),
  {
    fallback: loading,
  }
)
